import userManager from './utils/userManager';

userManager.signinSilentCallback();
